import React from 'react'

import ProductShopLink from '../productShopLink'

const ProductCard = ({ product, collection }) => {
  const productUrl = collection
    ? `/collections/${collection.handle}/products/${product.handle}`
    : `/products/${product.handle}`

  return (
    <div className='product-card' data-product-id={product.id}>
      <div className='product-card-top'>
        <a href={productUrl} className="product-image">
          {product.images[0] && (
            <img
              src={product.images[0].src}
              alt='product'
              className='featured-photo'
            />
          )}

          {product.images[1] && (
            <img
              src={product.images[1].src}
              alt='product'
              className='second-photo'
            />
          )}
        </a>
        <ProductShopLink productHandle={product.handle} />
      </div>
      <div className='product-card-bottom'>
        <p className='product-name'>{product.title}</p>
        <p className='product-variant'>
          {collection
            ? collection.title
            : product.firstCollectionTitle || product.collections[0].title}
          &nbsp;|&nbsp;$
          {product.variants[0].price}
        </p>
        <a className='product-link' href={productUrl}>
          Shop Now
        </a>
      </div>
    </div>
  )
}

export default ProductCard
